import { useMemo, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
// @ts-expect-error no typings
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isUninitialized, isLoading, getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getHubSpotCallingEnabled } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import CallNumberSkeletons from './CallNumberSkeletons';
import GlobalCallingDisabled from './GlobalCallingDisabled';
import { isCallingFree } from 'calling-internal-common/utils/CallingSalesPro';
import UnlockCallingItem from 'calling-orchestration-shared-library/unlock-calling/components/UnlockCallingItem';
import { getCallingMinutesPerPortal } from 'calling-internal-common/utils/getCallingLimits';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { KB_URL_MANAGE_SEATS } from 'calling-orchestration-shared-library/constants/externalUrls';
import { TOOLTIP_PADDING_X, TOOLTIP_PADDING_Y } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallingOnboardingWorkspace__Wrapper",
  componentId: "sc-1ff9bqq-0"
})(["padding:", " ", ";"], TOOLTIP_PADDING_Y, TOOLTIP_PADDING_X);
function CallingOnboardingWorkspace({
  appIdentifier,
  asyncSettingsOmnibus,
  children,
  limits,
  scopes
}) {
  const isOmnibusDataUninitialized = isUninitialized(asyncSettingsOmnibus);
  const isOmnibusDataLoading = isLoading(asyncSettingsOmnibus);
  const omnibusData = getData(asyncSettingsOmnibus);
  const shouldShowCallingDisabled = useMemo(() => !getHubSpotCallingEnabled(omnibusData), [omnibusData]);
  const handleTracking = useCallback(() => {
    CommunicatorLogger.log('calling_callUpgradeClicked', {
      source: appIdentifier
    });
  }, [appIdentifier]);
  if (isOmnibusDataUninitialized || isOmnibusDataLoading) return /*#__PURE__*/_jsx(CallNumberSkeletons, {});
  if (shouldShowCallingDisabled) return /*#__PURE__*/_jsx(GlobalCallingDisabled, {});
  if (isCallingFree(scopes)) {
    if (getCallingMinutesPerPortal(limits)) {
      return /*#__PURE__*/_jsx(Wrapper, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "helpdesk.seatRequiredMessage_jsx",
          options: {
            href: KB_URL_MANAGE_SEATS,
            external: true
          },
          elements: {
            UILink
          }
        })
      });
    }
    return /*#__PURE__*/_jsx(UnlockCallingItem, {
      blockingType: "free-account-blocking",
      use: "popover",
      onTrack: handleTracking,
      "data-test-id": "free-account-blocking-popover",
      showIntegrationsLink: false
    });
  }
  return children;
}
CallingOnboardingWorkspace.propTypes = {
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  children: PropTypes.node.isRequired,
  scopes: ImmutablePropTypes.map.isRequired,
  appIdentifier: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(CallingOnboardingWorkspace);